import React from 'react'

const Help = () => {
  return (
    <div className="container mt-5 mb-5">
      <div className="row">
        <div className="col-sm-3 hidden-xs col-xs-12 text-center">
          <img src="./icon-group-people.png" style={{marginTop: "50px", width: "100%", maxWidth: "230px", height: "auto" }} />
        </div>
        <div className="col-sm-9 px-3">
          <h1 className="page-title">Help</h1>
          <p>Below are some common questions regarding our site and the COT reports:</p>
          <h2 className="question-title">When will you update your website with new COT reports?</h2>
          <p>We will update our website <strong>every Friday afternoon</strong> (U.S. time, excluding U.S. holidays), immediately after the CFTC releases new COT reports. Each COT report release includes <strong>data from the previous Tuesday</strong>.</p>
          <h2 className="question-title">Why do the COT reports on your website appear to be out of date?</h2>
          <p>The COT data on our site is up to date and not outdated. Each new COT report, which is released on Fridays once a week, covers data from the previous Tuesday. As a result, COT reports for the current date will be unavailable, and data may appear to be up to 10 days (or longer) "out of date". This is normal.</p>
        </div>
      </div>
    </div>
  )
}

export default Help